// Get DataExports
export const GET_DATA_EXPORTS_REQUEST = 'GET_DATA_EXPORTS_REQUEST';
export const GET_DATA_EXPORTS_DONE = 'GET_DATA_EXPORTS_DONE';
export const GET_DATA_EXPORTS_FAILED = 'GET_DATA_EXPORTS_FAILED';

// Operations
export const DATA_EXPORTS_SET_PAGE = 'DATA_EXPORTS_SET_PAGE';